import { BarChart, Grid, Lock } from "react-feather";
import React from "react";

export const routes = [
    { location: '/dashboard', label: 'dashboard', icon: <Grid size={ 20 } /> },
    { location: '/blocks-report', label: 'blocksReport', icon: <BarChart size={ 20 } /> },
    { location: '/protection-setup', label: 'protectionSettings', icon: <Lock size={ 20 } /> }
]